import styled from 'styled-components';
import { breakpointsMinWidth } from '../../../../../../../../common/styling';

export const Wrapper = styled.div`
  width: 100%;
  bottom: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;

  @media ${breakpointsMinWidth.tabletSm} {
    padding-bottom: 8px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    padding-bottom: 6px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding-bottom: 10px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    padding-bottom: 15px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
  }
`;

export const UniversityLogo = styled.img`
  max-width: 80px;
  margin: 0 10px;

  @media ${breakpointsMinWidth.tabletSm} {
    margin: 0 14px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    margin: 0 18px;
    max-width: ${(props) => `${(props.maxWidth * 1024) / 1920}px`};
  }
  @media ${breakpointsMinWidth.tabletLg} {
    margin: 0 24px;
    max-width: ${(props) => `${(props.maxWidth * 1280) / 1920}px`};
  }
  @media ${breakpointsMinWidth.desktopSm} {
    margin: 0 26.5px;
    max-width: ${(props) => `${(props.maxWidth * 1440) / 1920}px`};
  }
  @media ${breakpointsMinWidth.desktopMd} {
    margin: 0 35px;
    max-width: ${(props) => `${props.maxWidth}px`};
  }
`;

export const LinkWrap = styled.a``;
